<div
  class="record"
  *ngIf="
    searched &&
      products_current_datasource &&
      products_current_datasource.length > 0;
    else noResultsFound
  "
>
  <div
    class="container-fluid d-flex justify-content-between align-items-center py-3 flex-wrap spacing-container"
  >
    <!-- Left Side: Total Records -->
    <div
      class="fw-bold fs-5 total-records"
      style="
        background: linear-gradient(90deg, #3d89ff, #3d89ff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      "
    >
      Total Records: <span class="color_red2">{{ totalRecords }}</span>
    </div>

    <!-- Right Side: Buttons -->
    <div class="d-flex align-items-center gap-2">
      <button
        style="
          background-color: #ffcd04;
          padding: 8px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        "
        (click)="exportExcel('csv')"
      >
        <img src="../../../../assets/icons/download.png" />
        <span style="font-size: 12px; color: #000">CSV</span>
      </button>
      <button
        style="
          background-color: #ffcd04;
          padding: 8px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
        "
        (click)="exportExcel('xlsx')"
      >
        <img src="../../../../assets/icons/download.png" />
        <span style="font-size: 12px; color: #000">XLS</span>
      </button>
    </div>
  </div>

  <div
    id="tabledata"
    class="search_data_table"
    [ngClass]="{ 'full-screen': isFullScreen }"
  >
    <div
      class="p-top-10 search_data_table_body"
      [ngClass]="
        !isListView && productDetails
          ? 'search_data_table_view'
          : 'width_100_per'
      "
    >
      <div
        id="tabledata"
        class="search_data_table_body_box"
        [ngClass]="{ fullscreen: isFullScreen }"
        style="position: relative"
      >
        <div
          class="scroll-button-left bg_1 width_40 height_40 border-radius-50-per padding-3 m-t-30 m-r-10-neg z_index_3 shadow_effect_2 cursor_pointer"
          (click)="scrollLeft()"
        >
          <div
            style="
              background: #f2f6ff;
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
            "
          >
            <svg
              width="9"
              height="16"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.70415 1.90735e-05C7.55932 -0.000854492 7.41575 0.0280972 7.28167 0.0852137C7.14759 0.14233 7.02564 0.22649 6.92281 0.332864L0.320008 7.21929C0.115045 7.43433 0 7.72523 0 8.02844C0 8.33166 0.115045 8.62255 0.320008 8.8376L6.92281 15.724C7.13334 15.912 7.40413 16.0103 7.6811 15.9991C7.95806 15.988 8.22078 15.8682 8.41677 15.6638C8.61276 15.4594 8.72757 15.1854 8.73827 14.8966C8.74897 14.6077 8.65476 14.3253 8.47447 14.1057L2.653 8.03418L8.47447 1.96265C8.629 1.8028 8.73462 1.59875 8.77796 1.37631C8.8213 1.15386 8.80043 0.923006 8.71797 0.712933C8.63552 0.50286 8.49519 0.323004 8.31473 0.196107C8.13427 0.0692101 7.92179 0.00097084 7.70415 1.90735e-05Z"
                fill="#3d89ff"
              />
            </svg>
          </div>
        </div>
        <div #tableContainer class="search_data_table_body_box_container">
          <!-- List View -->
          <p-table
            [columns]="cols"
            [value]="products_current_datasource"
            styleClass="p-datatable-gridlines table_data"
            class="width_100_per"
            [lazy]="true"
            (onLazyLoad)="loadProducts($event)"
            [lazyLoadOnInit]="false"
            [paginator]="true"
            [rows]="rows"
            [filters]="tablefilter"
            [totalRecords]="totalRecords"
            [loading]="loading_table"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="TableRowsCounts"
            responsiveLayout="scroll"
            scrollDirection="horizontal"
            [scrollable]="true"
            scrollHeight="1285px"
            paginatorDropdownAppendTo="body"
          >
            >
            <ng-template pTemplate="colgroup" let-columns>
              <colgroup>
                <ng-container *ngFor="let col of columns">
                  <col
                    *ngIf="col.isDisplay == 1"
                    [style.width]="col.columnWidth"
                  />
                </ng-container>
              </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
              <tr class="color_black font_14 weight_600">
                <ng-container *ngFor="let col of columns">
                  <th
                    *ngIf="col.isDisplay == 1"
                    [pSortableColumn]="col.tableColumnName"
                  >
                    <div [style.width]="col.columnWidth">
                      {{ col.displayColumnName }}
                      <p-sortIcon [field]="col.tableColumnName"></p-sortIcon>
                    </div>
                  </th>
                </ng-container>
              </tr>
              <tr>
                <ng-container *ngFor="let col of columns">
                  <th *ngIf="col.isDisplay == 1" [ngClass]="filterClass(col)">
                    <div [style.width]="col.columnWidth">
                      <p-columnFilter
                        style="width: 100%"
                        [type]="col.fieldDataType"
                        [field]="col.tableColumnName"
                        matchMode="contains"
                        [matchModeOptions]="
                          col.fieldDataType == 'date' ? matchModeOptions : null
                        "
                        [showOperator]="false"
                        [showAddButton]="false"
                        [display]="col.fieldDataType == 'date' ? 'menu' : 'row'"
                      >
                        <ng-template
                          *ngIf="col.fieldDataType == 'date'"
                          pTemplate="filter"
                        >
                          <p-calendar
                            [yearNavigator]="true"
                            yearRange="1900:2100"
                            [(ngModel)]="dateValue[col.field]"
                            name="dateValue"
                            (onSelect)="filterDate($event, col.field)"
                          >
                          </p-calendar>
                        </ng-template>
                      </p-columnFilter>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr class="color_black font_12 weight_500">
                <ng-container *ngFor="let col of columns">
                  <td *ngIf="col.isDisplay == 1" class="table__td">
                    <div
                      class="table__tddatabox"
                      [style.width]="col.columnWidth"
                    >
                      <span
                        appHighlight
                        [searchedWords]="searchedWords"
                        [text]="addDataSpace(rowData[col.tableColumnName])"
                        classToApply="highlight__keyword_1"
                      ></span>

                      <button
                        (click)="
                          showReadMore(
                            col.displayColumnName,
                            rowData[col.tableColumnName]
                          )
                        "
                        *ngIf="rowData[col.tableColumnName]?.length > 85"
                        pButton
                        pRipple
                        type="button"
                        label="Read More"
                        icon="pi pi-window-maximize"
                        class="p-button-rounded p-button-info"
                      ></button>
                    </div>
                  </td>
                </ng-container>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <div
          class="scroll-button-right bg_1 width_40 height_40 border-radius-50-per padding-3 m-t-30 m-l-20-neg z_index_3 shadow_effect_2 cursor_pointer"
          (click)="scrollRight()"
        >
          <div
            class="scroll-button-right bg_2 width_100_per height_100_per dis_flex jc_center align_center border-radius-50-per"
            style="
              background: #f2f6ff;
              height: 40px;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
            "
          >
            <svg
              width="9"
              height="16"
              viewBox="0 0 9 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.29585 1.90735e-05C1.44068 -0.000854492 1.58425 0.0280972 1.71833 0.0852137C1.85241 0.14233 1.97436 0.22649 2.07719 0.332864L8.67999 7.21929C8.88496 7.43433 9 7.72523 9 8.02844C9 8.33166 8.88496 8.62255 8.67999 8.8376L2.07719 15.724C1.86666 15.912 1.59587 16.0103 1.3189 15.9991C1.04194 15.988 0.779219 15.8682 0.583231 15.6638C0.387244 15.4594 0.272429 15.1854 0.261731 14.8966C0.251033 14.6077 0.345241 14.3253 0.525526 14.1057L6.347 8.03418L0.525526 1.96265C0.370996 1.8028 0.265384 1.59875 0.222041 1.37631C0.178699 1.15386 0.199574 0.923006 0.282028 0.712933C0.364481 0.50286 0.504808 0.323004 0.685267 0.196107C0.865726 0.0692101 1.07821 0.00097084 1.29585 1.90735e-05Z"
                fill="#3d89ff"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Read More Dialog -->
<div
  class="modal fade bg_4 fields_modal"
  id="read_more_modal"
  tabindex="-1"
  aria-labelledby="read_more"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content bg_1" style="position: relative">
      <div class="model-close-btn" data-bs-dismiss="modal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          x="0px"
          y="0px"
          width="20"
          height="20"
          viewBox="0 0 30 30"
        >
          <path
            d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"
          ></path>
        </svg>
      </div>
      <div class="modal-body fields_modal_body">
        <div class="fields_modal_body_top">
          <div
            class="fields_modal_body_top_item1 color_red2 font_20 weight_700"
          >
            {{ readMoreColumn }}
          </div>
        </div>
        <div class="fields_modal_body_center">
          <div
            appHighlight
            [searchedWords]="searchedWords"
            [text]="readMoreContent"
            classToApply="highlight__keyword_1"
          ></div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #noResultsFound>
  <div class="no-results-container" *ngIf="searched">
    <img
      src="../../../assets/img/no-data.png"
      class="no-results-image"
      alt="No data available"
    />
    <div class="no-results-message color_black">
      <span class="font_20 weight_800"
        >Sorry – The search found zero results. Why…</span
      >
      <ul class="no-results-list text_start">
        <li>
          <span class="font_20 weight_500"
            >Make sure you have selected the correct search criteria</span
          >
        </li>
        <li>
          <span class="font_20 weight_500"
            >Make sure that all words are spelled correctly</span
          >
        </li>
        <li>
          <span class="font_20 weight_500">Try different keywords</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try more general keywords</span>
        </li>
      </ul>
    </div>
    <!-- Back to search button -->
    <button
      class="btn-back-to-search"
      *ngIf="filterAppliedWithNoResults"
      (click)="goBackToSearch()"
    >
      <i class="pi pi-arrow-left"></i>
      Back to Search
    </button>
  </div>
</ng-template>
